export const API_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_API_URL_PRODUCTION
  //  : process.env.REACT_APP_API_URL_TEST;
    : process.env.REACT_APP_API_URL_PRODUCTION;

export const API_URL_STAGING =process.env.REACT_APP_API_URL_STAGING;